import React, { ReactNode } from "react";

class PieceFilterAmountListElementInfo {
    name: string;
    available: number;

    constructor(name: string, available: number) {
        this.name = name;
        this.available = available;
    }
}

//unused
class PieceFilterAmountListElementData {
    name: string;
    amount: number;
    id: number;
    icon?: ReactNode;

    constructor(name: string, amount: number, id?: number, icon?: ReactNode) {
        this.name = name;
        this.amount = amount;
        this.id = id ? id : -1;
        this.icon = icon;
    }
}

export {PieceFilterAmountListElementInfo, PieceFilterAmountListElementData};